<template>
  <div v-if="props.isPiecePicker">
    <div id="piece_picker_board">
    </div>
  </div>
  <div v-if="!props.isPiecePicker">
    <div id="board_container">
    </div>
  </div>
  
 </template>
 
 <script setup>
 
   // https://github.com/shaack/cm-chessboard
 
   import { Chessboard, COLOR , INPUT_EVENT_TYPE, BORDER_TYPE , PIECES_FILE_TYPE } from '@/cm-chessboard/src/Chessboard.js';
   import { FEN } from '@/cm-chessboard/src/model/Position.js';
   import {MARKER_TYPE, Markers} from "@/cm-chessboard/src/extensions/markers/Markers.js"
   import {ARROW_TYPE, Arrows} from "@/cm-chessboard/src/extensions/arrows/Arrows.js"
   import { PromotionDialog} from "@/cm-chessboard/src/extensions/promotion-dialog/PromotionDialog.js"
 
   // taken from Board.vue
   import { ref, onMounted, onBeforeUnmount } from 'vue'
   import { watch } from "vue";
   import { computed } from "@vue/reactivity"
   import { useConnectionStore } from '@/stores/connectionStore';
 
   import { buildPieceLocationStrings , columnToNumber} from '@/composables/blindfoldSupport.js'
 
   const props = defineProps({
     fen : String,
     orientation : String,
     resetFromTo : {
       type : Number,
       default : 0
     },
     validMoves : {
       type : Array,
       default : []
     },
     boardSize : Number,
     arrows : {
       type : Array,
       default : null
     },
     setSquareColor : {
       type : Array,
       default : null
     },
     hint : {
       type : Array,   // 0=currentFen, 1=fen to hint to
       default : null
     },
     animateOnePly : {
       type : Array,   // 0=currentFen, 1=fen to animate to
       default : null
     },
     flagBadMove : {
       type : Boolean,
       default : false
     },
     animateSequence : {
       type : Array,
       default : null
     },
     reportFromTo : {
       type : Boolean,
       default : false
     },
     sparePieces : {
       type : String,
       default : ""
     },
     pieceSet : {
       type : String,
       default : "regular"
     },
     emitPosition : {
       type : Number,
       default : 0,
    },
    doEmitEveryMove : {
      type : Boolean,
      default : false
    },

    // the 2x6 display of pieces
    isPiecePicker : {
      type : Boolean,
      default : false
    },

    // piece is available to put on the board
    sideCarPiece : {
      type : String,
      default : ""
    },

    // use the promotion dialog box to select piece
    canPromoteToAnyPiece : {
      type : Boolean,
      default : false
    }

  })
 

  const divID = ref((props.isPiecePicker) ? "piece_picker_board" : "board_container")

   const emit = defineEmits(['board-move','move-animated','board-from-to-tap',
                 'board-position','move-made'])
 
   const connectionStore = useConnectionStore()
 
   var coordinates = connectionStore.getCoordinateLocation   
   //console.log("in cmboard",coordinates)
   const showCoordinates = !props.isPiecePicker && (coordinates == "out" || coordinates == "in")
   var borderType = (coordinates == "out") ? BORDER_TYPE.frame : BORDER_TYPE.thin
   if (props.isPiecePicker)
    borderType = BORDER_TYPE.none
 
   const boardColors = connectionStore.getDarkBoardColors

   var boardColorCSS = "chessvis-light"
   switch (boardColors) {
      // case "light" :
      //   boardColorCSS = "chessvis-light"
      //   break
      case "chessvis" :
        boardColorCSS = "chessvis-dark"
        break
      case "lichess" :
        boardColorCSS = "lichess-dark"
        break
   }
   
   // the 2x6 display of pieces
   if (props.isPiecePicker)
     boardColorCSS = "selector-dark"

   var board_container_div = null
   var boardDiv = null
 
   var pieceSetSvg = getPieceSetNameSVG(props.pieceSet)
   var savedPosition = ""
 
   // if "touch device", gets the touchstart & end for everything. Only mousedown & mouseup when touching
   //                    empty squares.  Seeing this on IOS. touch comes in first
   var isTouchDevice = false
 
   // visualized puzzle - tap from , tap to -- don't move pieces, don't care what is there
   var TAP_ANY_FROM_SQUARE = 0
   var TAP_ANY_TO_SQUARE = 1
   var fromToState = -1
   var tapAnySquareFrom = ""
   var tapAnySquareTo = -1
   var fromToFlag = props.reportFromTo
   const resetFromTo = computed({get() {return props.resetFromTo}})
   var savedOrientation =  COLOR.white
 
   // bad move flag info
   var badMoveFlagged = false
 
   const hint = computed({ get() { return props.hint }})
   const animateOnePly = computed({get() {return props.animateOnePly}})
   const animateSequence = computed({get() { return props.animateSequence}})
   const fen = computed({get() {return props.fen }})
   const arrows = computed({ get() {return props.arrows}})
   const setSquareColor = computed({get() {return props.setSquareColor}})
   const orientation = computed({get() {return props.orientation}})
   const reportFromTo = computed({get() {return props.reportFromTo}})
   const boardSize = computed({get() {return props.boardSize}})
   const pieceSet = computed({get() {return props.pieceSet}})
   const emitPosition = computed({get() {return props.emitPosition}})
   
   watch(boardSize, (newVal,oldVal) => {
     //console.log('*********** boardsize changed',newVal)
     // styleObject.value.width = newVal + "px"
     // styleObject.value.height = newVal + "px"
     // board.resize(newVal)
   })
 
   watch(fen, (newVal,oldVal) => {
     //console.log('*********** fen changed',newVal)
     chessboard.setPosition(newVal,false)
   })
 
   
   watch(reportFromTo, (newVal,oldVal) => {
     //console.log('*********** report From to changed',newVal)
     fromToFlag = newVal
   })
 
   watch(resetFromTo, (newVal,oldVal) => {
     //console.log('*********** RESET From to changed',newVal)
     fromToState = -1
     tapAnySquareFrom = ""
     tapAnySquareTo = -1
   })
 
   watch (arrows , (newVal,oldVal) => {
    //console.log("**** IN BOARD -- arrows",newVal)

    chessboard.removeArrows()

    // for "learn with coach", there's a 3rd element of color  from-to-color
    for (var i=0; i < newVal.length; i++) {
    const fromTo = newVal[i].split("-")
      
      if (fromTo.length == 3) {
        switch (fromTo[2]) {
          case "ignore" :
            break
          case "red" :
            chessboard.addArrow(ARROW_TYPE.red, fromTo[0], fromTo[1])
            break
          default :
          case "blue" :
            chessboard.addArrow(ARROW_TYPE.blue, fromTo[0], fromTo[1])
            break
          case "yellow" :
            chessboard.addArrow(ARROW_TYPE.yellow, fromTo[0], fromTo[1])
            break
          case "green" :
            chessboard.addArrow(ARROW_TYPE.green, fromTo[0], fromTo[1])
            break
        }
      }
      else
        chessboard.addArrow(ARROW_TYPE.default, fromTo[0], fromTo[1])

    }   
   })
 
   watch (setSquareColor , (newVal,oldVal) => {
       //console.log("**** IN BOARD -- setSquareColor",newVal)
 
       if (newVal.length == 0) {
         chessboard.removeMarkers()
         //console.log("********* clear square colors")
       }
       else {
         for (var i=0; i < newVal.length; i++) {
          var myOwnMarker = null
          switch (newVal[i].color) {
            case "circle" :
              chessboard.addMarker(MARKER_TYPE.circlePrimary,newVal[i].square)
              break
            case "red" :
              myOwnMarker = {class: "bad-square", slice: "markerSquare"}
              chessboard.addMarker(myOwnMarker,newVal[i].square)
              break
            case "blue" :
              myOwnMarker = {class: "blue-square", slice: "markerSquare"}
              chessboard.addMarker(myOwnMarker,newVal[i].square)
              break
            case "yellow" :
              myOwnMarker = {class: "yellow-square", slice: "markerSquare"}
              chessboard.addMarker(myOwnMarker,newVal[i].square)
              break
            default :
            case "green" :
              myOwnMarker = {class: "good-square", slice: "markerSquare"}
              chessboard.addMarker(myOwnMarker,newVal[i].square)
              break
            case "yellow_frame" :
              myOwnMarker = {class: "marker-frame-yellow", slice: "markerFrame"}
              chessboard.addMarker(myOwnMarker,newVal[i].square)
              break
            case "green_frame" :
              myOwnMarker = {class: "marker-frame-green", slice: "markerFrame"}
              chessboard.addMarker(myOwnMarker,newVal[i].square)
              break
            case "red_frame" :
              myOwnMarker = {class: "marker-frame-red", slice: "markerFrame"}
              chessboard.addMarker(myOwnMarker,newVal[i].square)
              break
            case "blue_frame" :
              myOwnMarker = {class: "marker-frame-blue", slice: "markerFrame"}
              chessboard.addMarker(myOwnMarker,newVal[i].square)
              break

            case "yellow_arrow" :
              myOwnMarker = {class: "marker-arrow-yellow", slice: "markerArrow"}
              chessboard.addMarker(myOwnMarker,newVal[i].square)
              break
            case "green_arrow" :
              myOwnMarker = {class: "marker-arrow-green", slice: "markerArrow"}
              chessboard.addMarker(myOwnMarker,newVal[i].square)
              break
            case "red_arrow" :
              myOwnMarker = {class: "marker-arrow-red", slice: "markerArrow"}
              chessboard.addMarker(myOwnMarker,newVal[i].square)
              break
            case "blue_arrow" :
              myOwnMarker = {class: "marker-arrow-blue", slice: "markerArrow"}
              chessboard.addMarker(myOwnMarker,newVal[i].square)
              break
            case "ignore" :
              chessboard.removeMarkers(undefined, newVal[i].square)
              break
          }
         }
       }
       //board.setSquareColor(newVal)
   })
 
   watch (orientation, () => {
     //console.log("board orientation ",orientation.value)
     savedOrientation = (orientation.value.charAt(0) == "w") ? COLOR.white : COLOR.black
     chessboard.setOrientation(savedOrientation)
   })
 
   watch(hint, (newVal,oldVal) => {
     //console.log('*********** HINT changed',newVal,oldVal)
     const currentFen = newVal[0]
     const hintFen = newVal[1]
     chessboard.setPosition(currentFen,false)
     chessboard.setPosition(hintFen,true)
     chessboard.setPosition(currentFen,true)  
   })
   
   watch(animateOnePly, (newVal,oldVal) => {
     //console.log('*********** Animate one ply changed',newVal,oldVal)
     const currentFen = newVal[0]
     const nextFen = newVal[1]
     chessboard.setPosition(currentFen,false)
     chessboard.setPosition(nextFen,true)
   })
 
   watch(animateSequence, (newVal,oldVal) => {
     //console.log('*********** Animate Sequence changed',newVal,oldVal)
 
     var index = 1
 
     function show_nextmove() {
       emit("move-animated",index - 1)
       chessboard.setPosition(newVal[index], true);
       if (index == newVal.length -1 )
         clearInterval(id)
       else
         index++;
     }
     chessboard.setPosition(newVal[0],false)
     if (newVal.length >= 2)
       var id = setInterval(show_nextmove, 750)
 
   })
 
   watch(pieceSet, (newVal,oldVal) => {
     //console.log('*********** PieceSet changed',newVal,oldVal)
 
     savedPosition = chessboard.getPosition()
     chessboard.destroy()
     board_container_div.removeChild(boardDiv)
     pieceSetSvg = getPieceSetNameSVG(newVal)
     makeNewBoard(true)
   })
 
   watch(emitPosition, (newVal,oldVal) => {
     const fen = chessboard.getPosition()
     emit("board-position",fen)
   })
 
   // new stuff
 
   var chessboard = null
 
   onMounted(() => {
     //console.log("board mounted")
     makeNewBoard(false)
   })
 
   function makeNewBoard(fromPieceSetChange) {
 
     const boardConfig = {
       position: (fromPieceSetChange) ? savedPosition : FEN.start,
       orientation: (fromPieceSetChange) ? savedOrientation : COLOR.white,
       animationDuration: 750,
       //assetsUrl: "./",
       assetsCache: (fromPieceSetChange) ? false : true,
       style: {
         showCoordinates: showCoordinates,
         borderType: borderType,
         cssClass: boardColorCSS,
         pieces: {
           type: PIECES_FILE_TYPE.svgSprite, // pieces are in an SVG sprite, no other type supported for now
           file: pieceSetSvg, // the filename of the sprite in `assets/pieces/`
           tileSize: 40 // the tile size in the sprite
         },
       },
       extensions: [{class: Markers}, {class: Arrows}, {class:PromotionDialog}]
     };
 
     //console.log("BOARD CONFIG ",boardConfig)
     board_container_div = document.getElementById(divID.value)
     //console.log("**** MAKE NEW BOARD ",divID.value)
     boardDiv = document.createElement("div")
     //boardDiv.setAttribute("class", "board1")
     board_container_div.appendChild(boardDiv)
     chessboard = new Chessboard(boardDiv, boardConfig);
     chessboard.enableMoveInput(inputHandler)
     chessboard.enableSquareSelect(eventHandler)
   }
 
   function inputHandler(event) {
     //console.log("input",event)
     //console.log("fromToFlag",fromToFlag)

     if (props.sideCarPiece != "")
       return (false)

     if (fromToFlag)
       return false
   
     //window.board.removeMarkers(MARKER_TYPE.frame)
     switch (event.type) {
       case INPUT_EVENT_TYPE.moveInputStarted:
 
         // static board and move following can only move a real piece
         if (props.sparePieces == "static" || props.sparePieces == "move") {
           const pieceAtSquare = chessboard.getPiece(event.squareFrom)
           if (pieceAtSquare == null)
             return (false)
         }
 
         chessboard.addMarker(MARKER_TYPE.frame, event.squareFrom)
         //console.log(`moveInputStarted: ${event.squareFrom}`)
         const isGoodFromSquare = checkValidFromSquare(event.squareFrom)
 
  
         return isGoodFromSquare
       case INPUT_EVENT_TYPE.validateMoveInput:
 
         // static board can't put a piece on top of another piece
         if (props.sparePieces == "static") {
           const pieceAtSquare = chessboard.getPiece(event.squareTo)
           if (pieceAtSquare != null)
             return (false)
         }
         
         //console.log("VALID MOVES",props.validMoves)
         //console.log(`validateMoveInput: ${event.squareFrom}-${event.squareTo}`)
         const isGoodMove = checkValidMove(event.squareFrom,event.squareTo)
         return isGoodMove
       case INPUT_EVENT_TYPE.moveInputCanceled:
         //console.log(`moveInputCanceled`)
         break
      case INPUT_EVENT_TYPE.moveInputFinished :
        //console.log(`moveInputFinished: ${event.squareFrom}-${event.squareTo}`)
        if (props.doEmitEveryMove) {
          //const uci = event.squareFrom + "-" + event.squareTo
          const fen = chessboard.getPosition()
          //console.log("        fen ",fen)
          emit('move-made',fen,event.squareFrom,event.squareTo)
        }
        break
     }
   }
   
   function eventHandler(event) {
     //console.log("event",event)
     //console.log("mouse event type",event.mouseEvent.type)
     switch (event.mouseEvent.type) {
       case "touchstart" :
         isTouchDevice = true
       case "mousedown" :
 
         // if "touch device" then ignore the mouse events
         if (isTouchDevice && event.mouseEvent.type == "mousedown")
           break
         
         // if visualized puzzle, only care about from/to square. can be any square
         if (fromToFlag) {
           if (fromToState == -1) {
             tapAnySquareFrom = event.square
             fromToState = TAP_ANY_FROM_SQUARE
             onFromTo(tapAnySquareFrom,"")
           }
           else {
             onFromTo(tapAnySquareFrom,event.square)
             fromToState = -1
           }
         }
         break
      case "touchend" :
      case "mouseup" :

          // if "touch device" then ignore the mouse events
          if (isTouchDevice && event.mouseEvent.type == "mouseup")
           break

         // are we in markup mode?
         if (props.sideCarPiece == "markup") {
          emit('move-made',"markup",event.square,event.square)
          break
         }

         // does the main board have a piece to put on the board?
         if (props.sideCarPiece != "") {
          var pieceAtSquare = chessboard.getPiece(event.square)
          pieceAtSquare = (pieceAtSquare == props.sideCarPiece) ? null : props.sideCarPiece
          chessboard.setPiece(event.square,pieceAtSquare,false).then(() => {
            if (props.doEmitEveryMove) {
              const fen = chessboard.getPosition()
              emit('move-made',fen,event.square,event.square)
            }
          })
         }
         break
     }
   }
 
   function onFromTo(fromUCI, toUCI) {
     //console.log("on from to ",fromUCI,toUCI)
 
     var tmp = fromUCI.split("")
     var colNumber = columnToNumber(tmp[0])
     const fromSquareNumber = (8 - tmp[1]) * 8 + colNumber
 
     if (toUCI != "") {
       var tmp = toUCI.split("")
       var colNumber = columnToNumber(tmp[0])
       const toSquareNumber = (8 - tmp[1]) * 8 + colNumber
       emit("board-from-to-tap",fromSquareNumber,toSquareNumber,fromUCI,toUCI)
     }
     else
       emit("board-from-to-tap",fromSquareNumber,-1,fromUCI,"")
   }
 
   function checkValidFromSquare(fromUCI) {
     const tmp = fromUCI.split("")
     const colNumber = columnToNumber(tmp[0])
     const squareNumber = (8 - tmp[1]) * 8 + colNumber
     //console.log('Drag started:', fromUCI,squareNumber)
 
     // if there is only one entry and the "from" value is "any" then everything is 'true'
     if (props.validMoves.length == 1 && props.validMoves[0].from == "any")
       return true
       
     if (badMoveFlagged) {
       chessboard.removeMarkers()
       badMoveFlagged = false
     }
 
     for (var i=0; i < props.validMoves.length; i++)
       if (props.validMoves[i].from == squareNumber) {
         return true
       }
 
     if (props.flagBadMove) {
       const myOwnMarker = {class: "bad-square", slice: "markerSquare"}
       chessboard.addMarker(myOwnMarker,fromUCI)
       badMoveFlagged = true
       emit("board-move",-1,fromUCI,"",squareNumber,-1)
     }
 
     return false
   }
 
   function checkValidMove(fromUCI, toUCI) {
     var tmp = fromUCI.split("")
     var colNumber = columnToNumber(tmp[0])
     var fromRowNumber = parseInt(tmp[1])
     const fromSquareNumber = (8 - tmp[1]) * 8 + colNumber
 
     var tmp = toUCI.split("")
     var colNumber = columnToNumber(tmp[0])
     var toRowNumber = parseInt(tmp[1])
     const toSquareNumber = (8 - tmp[1]) * 8 + colNumber
 
     //console.log("on drop",arguments,fromSquareNumber,toSquareNumber)
       
     // if there is only one entry and the "from" value is "any" then everything is 'true'
     // this is for "static boards" and "move following" -- always send the board position back too
     if (props.validMoves.length == 1 && props.validMoves[0].from == "any") {
       //console.log("newpos",newPos)
       return true
     }
 
    const pieceAtSquare = chessboard.getPiece(fromUCI)
    const isPromotion = ((pieceAtSquare == "wp" && toRowNumber == 8 && fromRowNumber == 7) ||
                    (pieceAtSquare == "bp" && toRowNumber == 1 && fromRowNumber == 2))
    const promotionColor = (pieceAtSquare == "wp") ? COLOR.white : COLOR.black

    if (props.canPromoteToAnyPiece && isPromotion) {
     
      chessboard.showPromotionDialog(toUCI, promotionColor, (result) => {
          const promotionPiece = (result == null) ? "q" : result.piece.split("")[1]
          //console.log("Promotion result", result)

          //console.log("valid move count",props.validMoves.length)
          //console.log("valdi moves",props.validMoves)
          for (var i=0; i < props.validMoves.length; i++) {
            if (props.validMoves[i].from != fromSquareNumber)
              continue
            if (props.validMoves[i].to != toSquareNumber)
              continue
            //console.log("check ",props.validMoves[i].promotion,promotionPiece)
            if (props.validMoves[i].promotion != promotionPiece)
              continue
            //console.log("match ",props.validMoves[i])
            emit("board-move",i,fromUCI,toUCI,fromSquareNumber,toSquareNumber,promotionPiece)
            return true
          }
          // if (result && result.piece) {
          //     chessboard.setPiece(result.square, result.piece, true)
          // } else {
          //     chessboard.setPosition(position)
          // }
          if (props.flagBadMove) {
        const myOwnMarker = {class: "bad-square", slice: "markerSquare"}
        chessboard.addMarker(myOwnMarker,toUCI)
        badMoveFlagged = true
        emit("board-move",-2,fromUCI,toUCI,fromSquareNumber,toSquareNumber)
        return true
      }
      return false
      })
      
    }
    else {
      for (var i=0; i < props.validMoves.length; i++) {
        if (props.validMoves[i].from != fromSquareNumber)
          continue
        if (props.validMoves[i].to != toSquareNumber)
          continue
        emit("board-move",i,fromUCI,toUCI,fromSquareNumber,toSquareNumber)
        return true
      }
 
     if (props.flagBadMove) {
       const myOwnMarker = {class: "bad-square", slice: "markerSquare"}
       chessboard.addMarker(myOwnMarker,toUCI)
       badMoveFlagged = true
       emit("board-move",-2,fromUCI,toUCI,fromSquareNumber,toSquareNumber)
     }
     return false
    }
   }
   
   function getPieceSetNameSVG(pieceSetName) {
     //console.log("calling getPieceSetName ",pieceSetName)
 
     switch (pieceSetName) {
       case "regular" :
         return ("standard.svg")
       case "one_color" :
         return ("standardwhite.svg")
       case "two_disks" :
         return ("twodisks.svg")
       case "one_disk" :
         return ("onedisk.svg")
       case "invisible" :
         return ("invisible.svg")
     }
     return ("standard.svg")
   }
   
 </script>
 
 <style scoped>
 
 @import '@/css/chessboard.css';
 @import '@/css/markers.css';
 @import '@/css/arrows.css';
 @import '@/css/promotion-dialog.css';
 
 </style>
 